(function () {
  'use strict';
  function toggleItem(item, open) {
    const trigger = item.querySelector('[data-faq-trigger]');
    const answer = item.querySelector('[data-faq-answer]');
    item.classList.toggle('is-open', open);
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      answer.hidden = false;
      answer.style.maxHeight = answer.scrollHeight + 'px';
    } else {
      answer.style.maxHeight = '0px';
      answer.addEventListener('transitionend', () => {
        if (!item.classList.contains('is-open')) answer.hidden = true;
      }, { once: true });
    }
  }
  function init() {
    const items = document.querySelectorAll('[data-faq-item]');
    items.forEach((item) => {
      const trigger = item.querySelector('[data-faq-trigger]');
      trigger.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');
        items.forEach((otherItem) => {
          if (otherItem !== item && otherItem.classList.contains('is-open')) {
            toggleItem(otherItem, false);
          }
        });
        toggleItem(item, !isOpen);
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
